import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  shiftStartDayOfProjectPhaseInProjectTemplate,
  ShiftStartDayOfProjectPhaseInProjectTemplatePayload,
} from '../../actions';
import { shiftStartDayOfProjectPhase } from '../../slices';

function* shiftStartDayProjectPhaseInProjectTemplateSaga({
  payload: { projectPhaseId, shiftBy },
}: StoreActionProps<ShiftStartDayOfProjectPhaseInProjectTemplatePayload>) {
  try {
    yield put(shiftStartDayOfProjectPhase({ projectPhaseId, shiftBy }));
  } catch (error) {
    logger.error('Error in shifting the start day of the phase', { error });

    message.error('There was an error while shifting the start day');
  }
}

export function* watchShiftStartDayOfProjectPhaseInProjectTemplateSaga(): Generator {
  yield takeLatest(
    shiftStartDayOfProjectPhaseInProjectTemplate.type,
    shiftStartDayProjectPhaseInProjectTemplateSaga,
  );
}
